export const TextHeader = ({ title, content, className }) => {
  return (
    <div className={`settings-container-item-header ${className}`}>
      <h3>{title}</h3>
      <p>{content}</p>
    </div>
  );
};